import { del, get, post, put } from "../../data/api";

export async function getWarehouses() {
    return await get("tool/warehouses");
}

export async function createWarehouse(dto) {
    return await post(dto, "tool/warehouses");
}

export async function updateWarehouse(id, dto) {
    return await put(dto, `tool/warehouses/${id}`);
}

export async function deleteWarehouse(id) {
    return await del(`tool/warehouses/${id}`);
}
